import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { deepCopyObject } from '../../utils/obj-utils';
import FormBuilder from '../helpers/form-builder';
import initialState from '../helpers/form-helpers/initial-state';
import * as userAccountActions from '../../../store/actions/user-account-actions';
import * as formStateHelpers from '../helpers/form-helpers/form-state-helper';
import * as formFieldDisplayHelpers from '../helpers/form-helpers/form-field-display-helpers';
import * as formScrollHelpers from '../helpers/form-scroll-helper';
import './email-notification-settings.scss';
import SSOFormFooter from '../../common/utility/SSOFormFooter';
import { formMessageConstants } from '../../utils/constants/form-message-constants';
import FormMessage from '../../common/utility/FormMessage';
import FormSpinner from '../../common/utility/FormSpinner';
import { getMultilineText } from '../../../../../general/js/utils';

class EmailNotificationSettingsForm extends Component {
    constructor(props) {
        super(props);

        const { formData } = props;

        const copyOfFormData = this.getSelectedFormData(props);

        this.state = {
            ...initialState.emailNotificationSettingsFormState,
            formData: copyOfFormData
        };

        this.displayEmailNotificationSettingsFrom = this.displayEmailNotificationSettingsFrom.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.submitUserData = this.submitUserData.bind(this);
        this.handleValidationResult = this.handleValidationResult.bind(this);

        this.formReferences = formScrollHelpers.getFormReferences(formData);

        this.handleUserDetailsUpdateSuccess = this.handleUserDetailsUpdateSuccess.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        const { isSaving } = this.state;
        const {
            loading,
            isUserDetailsUpdatedSuccessful,
        } = nextProps;

        if (isSaving &&
            !loading &&
            isUserDetailsUpdatedSuccessful) {
            this.setState(formStateHelpers.updateSavingState(false), this.handleUserDetailsUpdateSuccess);
        }

        if (isSaving &&
            !loading &&
            !isUserDetailsUpdatedSuccessful) {
            this.setState(formStateHelpers.updateSavingState(false));
        }
    }

    getSelectedFormData(props) {
        const { formData, accountData } = props;
        const { championships, channels, interests } = accountData.preferences;

        const copyOfFormData = deepCopyObject(formData);


        copyOfFormData.championshipSection.defaultValue = this.getSelectedValues(championships, copyOfFormData.championshipSection.choices);
        copyOfFormData.channelSection.defaultValue = this.getSelectedValuesFromProperty(channels, copyOfFormData.channelSection.choices);
        copyOfFormData.interestSection.defaultValue = this.getSelectedValuesFromProperty(interests, copyOfFormData.interestSection.choices);

        return copyOfFormData;
    }

    getSelectedValuesFromProperty(obj, choices) {
        if (obj == null) return null;

        const defaultChoices = [];

        Object.keys(obj).forEach((key) => {
            console.log(key, obj[key]);
            if (obj[key] === true) {
                const choiceItem = choices.find((o) => o.id.toUpperCase() === key.toUpperCase());
                if (choiceItem != null) defaultChoices.push(key);
            }
        });

        return defaultChoices;
    }

    getSelectedValues(selectedValues, choices) {
        if (selectedValues == null) return null;

        const defaultChoices = [];

        selectedValues.forEach((item) => {
            if (item.value) {
                const choiceItem = choices.find((o) => o.id.toUpperCase() === item.id.toUpperCase());
                if (choiceItem != null) defaultChoices.push(item.id);
            }
        });

        return defaultChoices;
    }

    handleUserDetailsUpdateSuccess() {
        const { refreshAccountPage } = this.props;
        refreshAccountPage(false);
    }

    componentWillUnmount() {
        const { actions } = this.props;
        this.setState(initialState.theOneClubFormState);
        actions.resetUserDetailsFormState();
    }

    handleSubmit(event) {
        event.preventDefault();
        const { formData } = this.state;
        this.setState(formStateHelpers.handleFormValidation(formData), this.handleValidationResult);
    }

    handleValidationResult() {
        if (this.state.formHasErrors) {
            const { errors } = this.state;
            formScrollHelpers.scrollToInvalidField(errors, this.formReferences);
            return;
        }

        this.setState(formStateHelpers.updateSavingState(true), this.submitUserData);
    }

    submitUserData() {
        const { actions, accountData } = this.props;
        const { formData } = this.state;
        const {
            callBackUrl,
            updatedNotificationSuccessMessage,
        } = formData;

        actions.updateUserEmailNotificationSettings({
            userDetails: this.state,
            accountData,
            actionSuccessText: updatedNotificationSuccessMessage,
            callBackUrl
        });
    }

    displayEmailNotificationSettingsFrom() {
        const { formData } = this.state;

        return FormBuilder({
            formData,
            formReferences: this.formReferences,
            handleChange: (event) => { this.setState(formStateHelpers.handleFieldChange(event.target)); },
            handleFieldChange: (event) => {
                const eventTarge = event.target;
                const fieldName = eventTarge.name;
                const fieldData = formData[fieldName];
                this.setState(formStateHelpers.handleFieldChangeWithValidation(eventTarge, fieldData));
            },
            handleFieldValidState: (fieldName) => {
                const { errors } = this.state;
                return formFieldDisplayHelpers.handleFieldValidState(fieldName, errors);
            }
        });
    }

    render() {
        const {
            loading,
            isUserDetailsUpdatedSuccessful,
            updateUserDetailsMessages,
        } = this.props;
        const { formData } = this.state;
        const {
            formTitle,
            formSubTitle
        } = formData;
        const formSubtitleSplit = getMultilineText(formSubTitle);

        return (
            <Fragment>
                <h1>{formTitle}</h1>
                {formSubtitleSplit.map((subtitle) => {
                    return <div key={_.uniqueId()} className='dashboard-info'
                        dangerouslySetInnerHTML={{
                            __html: subtitle
                        }}></div>;
                })}
                <div className='the-one-club'>
                    {loading ? <FormSpinner >/</FormSpinner> : null}
                    <div className='toc-form'>
                        <form>
                            <FormMessage isSuccessMessage={isUserDetailsUpdatedSuccessful}
                                messages={updateUserDetailsMessages}>
                            </FormMessage>
                            {this.displayEmailNotificationSettingsFrom()}
                            <SSOFormFooter
                                onSubmit={this.handleSubmit}
                                footerButtonText={formMessageConstants.updateNotificationSettings}
                            ></SSOFormFooter>
                        </form>
                    </div>
                </div>
            </Fragment>
        );
    }
}

EmailNotificationSettingsForm.propTypes = {
    formData: PropTypes.object.isRequired,
    accountData: PropTypes.object.isRequired,
    refreshAccountPage: PropTypes.func.isRequired,
};

function mapStateToProps(state) {
    return {
        loading: state.apiStatus.apiCallsInProgress > 0,
        isUserDetailsUpdatedSuccessful: state.userAccount.isUserDetailsUpdatedSuccessful,
        updateUserDetailsMessages: state.userAccount.updateUserDetailsMessages,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: {
            updateUserEmailNotificationSettings: bindActionCreators(userAccountActions.updateUserEmailNotificationSettings, dispatch),
            resetUserDetailsFormState: bindActionCreators(userAccountActions.resetUserDetailsFormState, dispatch)
        }
    };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(EmailNotificationSettingsForm);
